import Vue from "vue";
import commonActionHandle from "@/commonActionHandle";
import { GPURENTAL_STATUS_CODE, ERROR_SYSTEM_MESSAGE } from "@/constant/config";
import rentalApi from '@/api/rental';

const state = {
    listServicePack: [],
    gpuHubServicePack: [],
    cpuHubServicePack: [],
    remoteFarmServicePack: [],
    availabilityServiceList: [],
    countMachine: {},


    serverReport: []
};

const getters = {
    listServicePack: state => state.listServicePack,
    gpuHubServicePack: state => state.gpuHubServicePack,
    cpuHubServicePack: state => state.cpuHubServicePack,
    remoteFarmServicePack: state => state.remoteFarmServicePack,
    availabilityServiceList: state => state.availabilityServiceList,
    countMachine: state => state.countMachine,


    serverReport: state => state.serverReport,
};

const mutations = {

    // Dialog notification
    show_common_error(state, errorObj) {
        let msg = '';
        switch (errorObj.message) {
            case ERROR_SYSTEM_MESSAGE.error404:
                msg = Vue.prototype.$lang.message.error404;
                break;
            case ERROR_SYSTEM_MESSAGE.error500:
                msg = Vue.prototype.$lang.message.error500;
                break;
            default:
                msg = errorObj.message;
                break;
        }
        commonActionHandle.showCustomError(
            Vue.prototype.$lang.dialog.errorOpps,
            msg
        );
    },

    // Unknow error
    show_unkown_error(state, res, title) {
        console.error(res);
        commonActionHandle.showUnknowError(title);
    },

    get_service_pack(state, listServicePack) {
        state.listServicePack = listServicePack;
        state.gpuHubServicePack = [];
        state.remoteFarmServicePack = [];
        state.cpuHubServicePack = [];
        listServicePack.forEach(element => {
            switch (element.serviceType) {
                case 1:
                    state.gpuHubServicePack.push(element);
                    break;
                case 2:
                    state.remoteFarmServicePack.push(element);
                    break;
                case 3:
                    state.cpuHubServicePack.push(element);
                    break;
            }
        });
    },

    get_availability_service(state, listService) {
        state.availabilityServiceList = listService;
    },

    // Get user configuration
    get_user_configuration(state, data) {
        state.userConfigurationList = data;
    },

    // Count number machine
    count_number_machine(state, data) {
        state.countMachine = data;
    },


    server_report_view(state, data) {
        state.serverReport = data;
    },
};

const actions = {

    // Show error 404 500
    showCommonError({ commit }, errorObj) {
        commit("show_common_error", errorObj);
    },

    // Show unknow error
    showUnkownError({ commit }, res, title) {
        commit("show_unkown_error", res, title);
    },

    // Get service pack list
    getServicePack({ commit }) {
        rentalApi.getServicePackList()
            .then((res) => {
                try {
                    switch (res.errorCode) {
                        case GPURENTAL_STATUS_CODE.ListServicePack_Success:
                            commit("get_service_pack", res.data);
                            break;
                    }
                } catch (error) { }
            }).catch(error => { });
    },

    // Get availability service
    getAvailabilityService({ commit }) {
        rentalApi.getAvailabilityService()
            .then((res) => {
                try {
                    switch (res.errorCode) {
                        case GPURENTAL_STATUS_CODE.GetAllServerReport_Success:
                            commit("get_availability_service", res.data);
                            break;
                    }
                } catch (error) { }
            }).catch(error => { });
    },

    // Count number machine
    countNumberMachine({ commit }) {
        rentalApi.countNumberMachine()
            .then((res) => {
                try {
                    switch (res.errorCode) {
                        case GPURENTAL_STATUS_CODE.CountNumberMachine_Success:
                            commit("count_number_machine", res.data);
                            break;
                    }
                } catch (error) { }
            }).catch(error => { });
    },



    serverReportView({ commit }) {
        rentalApi.serverReportView()
            .then((res) => {
                try {
                    commit("server_report_view", res.data);
                } catch (error) { }
            }).catch(error => { });
    },
};

export default { namespaced: true, state, getters, mutations, actions };
